export default __webpack_public_path__ + "static/ico-24-4585f506e00565a83a92d4c4af78cce4.svg";